export const DEFAULT_VALUES = {
  keyCode: ''
}
